var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSend = function SvgSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.398 11.0819C17.227 8.83889 13.463 7.16089 10.706 5.93189C5.32896 3.53389 3.88296 2.88989 2.87596 2.88989C2.01196 2.88989 1.58696 3.41389 1.44696 3.58489C0.917958 4.23489 0.853958 5.15589 1.28496 5.87289L4.96096 11.9999L1.28596 18.1249C0.853958 18.8429 0.918958 19.7629 1.44796 20.4149C1.58796 20.5879 2.01296 21.1129 2.87796 21.1129C3.88396 21.1129 5.32396 20.4699 10.677 18.0819C13.437 16.8509 17.209 15.1679 22.399 12.9169C22.764 12.7579 23 12.3979 23 11.9989C23 11.6019 22.764 11.2399 22.398 11.0819ZM3.08296 4.91389C3.88296 5.07789 6.01196 6.02789 9.89096 7.75689C11.801 8.60889 14.203 9.67889 17.208 10.9979H6.69296L3.08296 4.91389ZM9.86196 16.2549C5.91996 18.0139 3.79296 18.9629 3.03496 19.0949L6.69296 12.9979H17.209C14.188 14.3269 11.776 15.4019 9.86196 16.2549Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send.b49e0c36.svg";
export { ForwardRef as ReactComponent };